import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from '@/App'
import '@/styles/global.css'

const rootEl = document.getElementById('root')!
const splash = document.getElementById('splash')

const readyAt = Date.now() + 2000

window.__dismissSplash = () => {
  const remaining = readyAt - Date.now()
  setTimeout(() => {
    if (!splash) return
    splash.style.animation = 'none'
    splash.style.opacity = '1'
    void splash.offsetHeight
    splash.style.transition = 'opacity 500ms ease'
    splash.style.opacity = '0'
    splash.addEventListener('transitionend', () => splash.remove(), { once: true })
    setTimeout(() => splash.remove(), 600)
  }, Math.max(0, remaining))
}

createRoot(rootEl).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)
